<template>
  <div>
    <b-modal
      id="user-edit-modal"
      :centered="true"
      :hide-header="true"
      :hide-footer="false"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <b-container fluid>
        <b-row class="my-1">
          <b-col sm="4" class="pr-0">
            <label for="last_name" class="col-form-label-sm">苗字</label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              id="last_name"
              v-model="last_name"
              type="text"
              :state="last_name_feedback === null ? null : !last_name_feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="last_name-feedback">{{ last_name_feedback }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4" class="pr-0">
            <label for="first_name" class="col-form-label-sm">名前</label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              id="first_name"
              v-model="first_name"
              type="text"
              :state="first_name_feedback === null ? null : !first_name_feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="first_name-feedback">{{ first_name_feedback }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4" class="pr-0">
            <label for="email" class="col-form-label-sm">メールアドレス</label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              id="email"
              v-model="email"
              type="text"
              :state="email_feedback === null ? null : !email_feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="email-feedback">{{ email_feedback }}</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4" class="pr-0">
            <label for="password" class="col-form-label-sm">パスワード(8字以上)</label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              id="password"
              v-model="password"
              type="password"
              :state="password_feedback === null ? null : !password_feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="password-feedback">{{ password_feedback }}</b-form-invalid-feedback>
            <p v-if="this.data.hasOwnProperty('id')">※入力時のみ更新</p>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col sm="4" class="pr-0">
            <label for="password_confirm" class="col-form-label-sm">パスワード(確認)</label>
          </b-col>
          <b-col sm="8">
            <b-form-input
              id="password_confirm"
              v-model="password_confirm"
              type="password"
              :state="password_confirm_feedback === null ? null : !password_confirm_feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="password_confirm-feedback">
              {{ password_confirm_feedback }}
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row v-if="isAdmin == 0" class="my-1">
          <b-col sm="4" class="pr-0">
            <label for="tags" class="col-form-label-sm">タグ</label>
          </b-col>
          <b-col sm="8">
            <div>
              <b-form-tags v-model="tags" input-id="tags" separator=" " placeholder="" remove-on-delete></b-form-tags>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <p class="sm">※パスワードには、半角英数と以下の記号が利用できます。<br />
        !"#$%&amp;'()*+,-./:;&lt;=&gt;?@[\]^_`{|}~</p>
        <b-button @click="handleCancel">キャンセル</b-button>
        <b-button variant="default" @click="handleOk">保存</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'UserEditModal',
  props: {
    data: Object,
    validations: Object,
    isAdmin: String,
    ok: Function,
    cancel: Function
  },
  mounted() {
    // モーダルを開いたときにdataをpropsで上書きする
    // computedのsetterはinputの変更時にしか呼ばれないため
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      this.initEditData()
    })
    // モーダルを閉じたときにdata(validations)を初期化する
    // 画面表示をリセットするため
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.initValidations()
    })
  },
  data() {
    return {
      tags_: [],
      last_name_: '',
      last_name_feedback: null,
      first_name_: '',
      first_name_feedback: null,
      email_: '',
      email_feedback: null,
      password_: '',
      password_feedback: null,
      password_confirm_: '',
      password_confirm_feedback: null
    }
  },
  computed: {
    tags: {
      get() {
        return (this.data.tags || []).map((item) => {
          // DBから取ってきたデータならitem.name、b-form-tagで編集されていたらitemがタグのテキスト
          return typeof item === 'string' ? item : item.name
        })
      },
      set(val) {
        this.tags_ = val
      }
    },
    last_name: {
      get() {
        return this.data.last_name
      },
      set(val) {
        this.last_name_ = val
      }
    },
    first_name: {
      get() {
        return this.data.first_name
      },
      set(val) {
        this.first_name_ = val
      }
    },
    email: {
      get() {
        return this.data.email
      },
      set(val) {
        this.email_ = val
      }
    },
    password: {
      get() {
        return this.password_
      },
      set(val) {
        this.password_ = val
      }
    },
    password_confirm: {
      get() {
        return this.password_confirm_
      },
      set(val) {
        this.password_confirm_ = val
      }
    }
  },
  watch: {
    validations: {
      handler: function (val, old) {
        this.initValidations()
        Object.keys(val).forEach((key) => {
          this[`${key}_feedback`] = val[key]
        })
      },
      deep: true
    }
  },
  methods: {
    initEditData() {
      this.tags_ = this.tags || []
      this.last_name_ = this.last_name || ''
      this.first_name_ = this.first_name || ''
      this.email_ = this.email || ''
      this.password_ = ''
      this.password_confirm_ = ''
    },
    initValidations() {
      this.last_name_feedback = null
      this.first_name_feedback = null
      this.email_feedback = null
      this.password_feedback = null
      this.password_confirm_feedback = null
    },
    getEditData() {
      return {
        tags: this.tags_,
        last_name: this.last_name_,
        first_name: this.first_name_,
        email: this.email_,
        password: this.password_,
        password_confirm: this.password_confirm_
      }
    },
    handleOk() {
      this.$emit('ok', this.getEditData())
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
